import { useField } from 'formik';
import { FC } from 'react';

import Form from '@controls/Form';

import { filterTitleStyles } from '../../../../../../styles';
import { getFieldName, isBooleanFilter } from '../../../../../../utils';
import FilterFieldRenderer from '../../../../../FilterForm/components/FilterFieldRenderer';
import {
    booleanFilterContainerStyles,
    booleanFilterFieldWrapperStyles,
    booleanFilterTitleStyles,
    filterItemContainerStyles,
} from './styles';
import { MobileFilterItemProps } from './types';

const MobileFilterItem: FC<MobileFilterItemProps> = ({
    filterField,
    fieldPrefix,
    expandedFilters,
    toggleFilter,
    onFilterChange,
}) => {
    const filterItems = filterField.values || [];
    const isBoolean = isBooleanFilter(filterItems);
    const fieldName = fieldPrefix ? `${fieldPrefix}_${filterField.code}` : String(filterField.code);
    const [field] = useField<(string | number)[] | boolean>(fieldName);

    const handleBooleanFilterChange = (changedFieldName: string, newValue: (string | number)[] | undefined) => {
        const valueToPass =
            newValue !== undefined
                ? newValue
                : typeof field.value === 'boolean'
                  ? field.value
                      ? ['true']
                      : []
                  : field.value || [];
        onFilterChange?.(changedFieldName, valueToPass);
    };

    const handleFilterChange = (changedFieldName: string, newValue: (string | number)[] | undefined) => {
        const valueToPass = newValue !== undefined ? newValue : (field.value as (string | number)[]) || [];
        onFilterChange?.(changedFieldName, valueToPass);
    };

    if (isBoolean) {
        return (
            <div css={filterItemContainerStyles}>
                <div css={booleanFilterContainerStyles}>
                    <span css={[filterTitleStyles, booleanFilterTitleStyles]}>{filterField.name}</span>
                    <div css={booleanFilterFieldWrapperStyles}>
                        <Form.Field name={fieldName}>
                            <FilterFieldRenderer
                                filterField={filterField}
                                expandedFilters={expandedFilters}
                                fieldPrefix={fieldPrefix}
                                onToggle={toggleFilter}
                                onFilterChange={handleBooleanFilterChange}
                            />
                        </Form.Field>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div css={filterItemContainerStyles}>
            <div css={filterTitleStyles}>{filterField.name}</div>
            <Form.Field name={fieldName}>
                <FilterFieldRenderer
                    filterField={filterField}
                    expandedFilters={expandedFilters}
                    fieldPrefix={fieldPrefix}
                    onToggle={toggleFilter}
                    onFilterChange={handleFilterChange}
                />
            </Form.Field>
        </div>
    );
};

export default MobileFilterItem;
